module.exports = __webpack_public_path__ + "static/img/home_yali_photo1@2x.49636cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_yali_photo1@2x.png
// module id = IzdO
// module chunks = 0